<template>
    <v-card  class="" elevation=0 >

        <v-card-text class="mb-auto pb-90">
            <v-row class="align-center">
                <v-col cols="12" md="12" sm="12" class="text-center " >
                    <img :src="logoImg" alt="" width="60" height="60" class="align-center"/>
                </v-col>

                <v-col cols="12" md="12" sm="12" class="text-center">
                    <div>Coronaviruses</div>
                    <div>(COVID-19) </div>
                    <div class="text-justify body-2 " >Staying informed is the best protection from any type of infection, you can help by keeping us informed on your health, please answer the following questions.</div>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" md="12" sm="12" class="text-center " >
                    <v-form v-model="valid" enctype="multipart/form-data" id="createcoronasurvey">
                        <v-card class="card-back">
                            <v-row>
                                <v-col cols="12" md="12" sm="12" class="text-center " >
                                    <div>Do you feel unwell in any way?</div>
                                </v-col>
                                <v-col cols="12" md="12" sm="12" class="text-center ">
                                    <v-radio-group v-model="row" row class="text-center pr-30 pl-30 mt-0" align="center" name="unwell" dark >
                                        <v-radio label="No" value="0" class="white--text" color="white" dark></v-radio>
                                        <v-radio label="Yes" value="1" class="white--text" color="white" dark></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </v-card>

                        <v-card class="card-back mt-3">
                            <v-row>
                                <v-col cols="12" md="12" sm="12" class="text-center " >
                                    <div>Do you have a fever?</div>
                                </v-col>
                                <v-col cols="12" md="12" sm="12" class="text-center ">
                                    <v-radio-group v-model="row" row class="text-center pr-30 pl-30 mt-0" align="center" name="fever">
                                        <v-radio label="No" value="0" class="white--text" color="white" dark></v-radio>
                                        <v-radio label="Yes" value="1" class="white--text" color="white" dark></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </v-card>

                        <v-card class="card-back mt-3">
                            <v-row>
                                <v-col cols="12" md="12" sm="12" class="text-center " >
                                    <div>Do you have a dry cough?</div>
                                </v-col>
                                <v-col cols="12" md="12" sm="12" class="text-center ">
                                    <v-radio-group v-model="row" row class="text-center pr-30 pl-30 mt-0" align="center" name="cough" dark>
                                        <v-radio label="No" value="0" class="white--text" color="white"></v-radio>
                                        <v-radio label="Yes" value="1" class="white--text"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </v-card>

                        <v-card class="card-back mt-3">
                            <v-row>
                                <v-col cols="12" md="12" sm="12" class="text-center " >
                                    <div>Do you feel more tired than normal?</div>
                                </v-col>
                                <v-col cols="12" md="12" sm="12" class="text-center ">
                                    <v-radio-group v-model="row" row class="text-center pr-30 pl-30 mt-0" align="center" name="tired" dark>
                                        <v-radio label="No" value="0" class="white--text" color="white--text "></v-radio>
                                        <v-radio label="Yes" value="1" class="white--text"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </v-card>

                        <v-card class="card-back mt-3">
                            <v-row>
                                <v-col cols="12" md="12" sm="12" class="text-center " >
                                    <div>Have You been vomiting?</div>
                                </v-col>
                                <v-col cols="12" md="12" sm="12" class="text-center ">
                                    <v-radio-group v-model="row" row class="text-center pr-30 pl-30 mt-0" align="center" name="vomiting" dark>
                                        <v-radio label="No" value="0" class="white--text" color="white--text "></v-radio>
                                        <v-radio label="Yes" value="1" class="white--text"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </v-card>

                        <v-card class="card-back mt-3">
                            <v-row>
                                <v-col cols="12" md="12" sm="12" class="text-center " >
                                    <div>Have You suffered from diarrhea?</div>
                                </v-col>
                                <v-col cols="12" md="12" sm="12" class="text-center ">
                                    <v-radio-group v-model="row" row class="text-center pr-30 pl-30 mt-0" align="center" name="diarrhoea" dark>
                                        <v-radio label="No" value="0" class="white--text" color="white--text "></v-radio>
                                        <v-radio label="Yes" value="1" class="white--text"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </v-card>

                        <v-card class="card-back mt-3">
                            <v-row>
                                <v-col cols="12" md="12" sm="12" class="text-center " >
                                    <div>Have You have sore throat?</div>
                                </v-col>
                                <v-col cols="12" md="12" sm="12" class="text-center ">
                                    <v-radio-group v-model="row" row class="text-center pr-30 pl-30 mt-0" align="center" name="throat" dark>
                                        <v-radio label="No" value="0" class="white--text" color="white--text "></v-radio>
                                        <v-radio label="Yes" value="1" class="white--text"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </v-card>

                        <v-card class="card-back mt-3">
                            <v-row>
                                <v-col cols="12" md="12" sm="12" class="text-center " >
                                    <div>Do you have an nasal congestion?</div>
                                </v-col>
                                <v-col cols="12" md="12" sm="12" class="text-center ">
                                    <v-radio-group v-model="row" row class="text-center pr-30 pl-30 mt-0" align="center" name="congestion" dark>
                                        <v-radio label="No" value="0" class="white--text" color="white--text "></v-radio>
                                        <v-radio label="Yes" value="1" class="white--text"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </v-card>

                        <v-card class="card-back mt-3">
                            <v-row>
                                <v-col cols="12" md="12" sm="12" class="text-center " >
                                    <div>Have you got a runny nose?</div>
                                </v-col>
                                <v-col cols="12" md="12" sm="12" class="text-center ">
                                    <v-radio-group v-model="row" row class="text-center pr-30 pl-30 mt-0" align="center" name="runny_nose" dark>
                                        <v-radio label="No" value="0" class="white--text" color="white--text "></v-radio>
                                        <v-radio label="Yes" value="1" class="white--text"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </v-card>

                        <v-card class="card-back mt-3">
                            <v-row>
                                <v-col cols="12" md="12" sm="12" class="text-center " >
                                    <div>Have you lost your appertite?</div>
                                </v-col>
                                <v-col cols="12" md="12" sm="12" class="text-center ">
                                    <v-radio-group v-model="row" row class="text-center pr-30 pl-30 mt-0" align="center" name="appetite" dark>
                                        <v-radio label="No" value="0" class="white--text" color="white--text "></v-radio>
                                        <v-radio label="Yes" value="1" class="white--text"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </v-card>

                    </v-form>
                </v-col>
                <v-divider></v-divider>

                <v-col cols="12" md="12" sm="12" class="text-center " >
                    <div class="text-center">
                        <v-btn color="primary" @click="submit">Submit</v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
import Vue from 'vue'
export default
{
    props: ['business','tag'],
    data: () => ({
        logoImg:require('@/assets/logo.png'),
    }),
    methods:
    {
        submit()
        {

            let th = this;
            if(this.$validator.validateAll())
            {
                let fd = new FormData(document.getElementById('createcoronasurvey'));
                fd.append('business_id',this.business.id);
                fd.append('businesstags_id',this.tag);
                this.$http.post('https://api.juzzap.com/api/createCoronaservey',fd)
                .then(res=>{
                    if(res.data.success)
                    {
                        this.$router.push('/businessDetails/'+this.tag+'/coronafeedback');
                    }
                    else
                    {
                        let errmsg=[];
                        for(var prop in res.data.errors){
                            errmsg.push(res.data.errors[prop][0]);
                        }
                            //alert(errmsg[0]);
                    }

                })
                .catch(err=>{
                console.log(err.response);
                });

            }

        }
    }
}
</script>
<style scoped>
.card-back
{
    background:#FE5800 !important;
    color:#fff !important;
}
.pl-30
{
    padding-left:80px !important;
}
.pr-30
{
    padding-right:80px !important;
}

</style>
